import { FC } from "react";
import "./ScoreCardHeader.css";
import appIcon from "../../../assets/images/header-app-icon.svg";
import backIcon from "../../../assets/images/back-icon.svg";
import { useNavigate } from "react-router-dom";

interface ScoreCardHeaderProps {
  title: string;
  subTitle: string;
  orangeFirst?: boolean;
  showBackButton?: boolean;
}

const ScoreCardHeader: FC<ScoreCardHeaderProps> = ({
  title,
  subTitle,
  orangeFirst = false,
  showBackButton = false,
}) => {
  const navigate = useNavigate();

   const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <header className="score-card-header-bar">
      {showBackButton ? (
        <img
          src={backIcon}
          alt="dropdown-logo"
          className="score-card-header-back-button"
          onClick={handleBackButtonClick}
        />
      ) : (
        <>
          <div className="score-card-header-left-container">
            <img src={appIcon} alt="logo" />
          </div>
          <div className="score-card-header-divider"></div>
        </>
      )}
      <div className="score-card-header-right-container">
        <span>
          {orangeFirst ? (
            <>
              <span style={{ color: "#FF6B35" }}>{subTitle}</span> {title}
            </>
          ) : (
            <>
              {title} <span style={{ color: "#FF6B35" }}>{subTitle}</span>
            </>
          )}
        </span>
      </div>
    </header>
  );
};

export default ScoreCardHeader;
